import { combineReducers } from "@reduxjs/toolkit"

import socketSlice from "../admin-slices/socket.slice"
import otherSlice from "../guest-slices/other.slice"
import authSlice from "../admin-slices/auth.slice"
import dashboardSlice from "../admin-slices/dashboard.slice"

const rootReducer = combineReducers({
  // Admin slice
  authSlice,
  socketSlice,
  dashboardSlice,

  // Guest slice
  otherSlice,
})

export default rootReducer